<template>
  <main>
    <div class="mentions box-border p-3">
      <div>
        <div>
          <div class="pb-4">
            <div class="w-full text-center mt-10 text-2xl text-secondary">
              <h2 class="uppercase text-lg font-bold text-center w-full">
                MENTIONS LÉGALES
              </h2>
            </div>
            <div><br /></div>
            <div v-html="data.society_editor"></div>
            <div><br /></div>

            <div
              v-if="
                data.custom.responsable_info &&
                data.custom.responsable_info != '<div><br></div>'
              "
            >
              <div v-html="data.custom.responsable_info" />
            </div>
            <div class="text-center" v-else>
              <div><strong>RESPONSABLE DE TRAITEMENT :</strong></div>
              <div>Husqvarna France</div>
              <div>SAS au capital de 2 063 096 euros</div>
              <div>Siège social :</div>
              <div>22, rue Dora Maar</div>
              <div>93400 Saint Ouen</div>
              <div>SIRET: 315 256 222 00060</div>
              <div>APE: 4661Z</div>
              <div><br /></div>
            </div>

            <div class="text-center py-4">
              <div>
                <strong
                  ><span class="font-bold "
                    >HEBERGEMENT</span
                  ><br />
                  Hébergement des données:</strong
                >
              </div>
              <div>
                MongoDb Limited Building<br />
                2 Number One Ballsbridge,<br />Shelbourne Rd
              </div>
              <div>Ballsbridge, Dublin 4,</div>
              <div>D04 Y3X9, Irlande</div>
              <div>Téléphone : +35319014654</div>
              <div>Email : support@mongodb.com</div>
              <div>
                <br /><strong>Localisation des centres de données:</strong>
              </div>
              <div>
                Les données sont hébergées <br />dans les centres situées en
                France par:
              </div>
              <div>Amazon Web Service (AWS)</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { ref } from "vue";
const data = ref({
  society_editor: "",
  custom: {
    responsable_info: "",
  },
});

const fetchOperation = async () => {
  try {
    const response = await fetch(
      `https://api.husqvarna-promo.fr/api/v2/formdata/678e5cf5f45160b0ac8cc75d`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Erreur HTTP: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error(`Erreur lors de la requête :`, error);
    throw error;
  }
};

onMounted(async () => {
  data.value = await fetchOperation();
  console.log(data.value);
});
</script>
